import { render } from "./ColumnUi.vue?vue&type=template&id=70ff18d1&scoped=true"
import script from "./ColumnUi.vue?vue&type=script&lang=js"
export * from "./ColumnUi.vue?vue&type=script&lang=js"

import "./ColumnUi.vue?vue&type=style&index=0&id=70ff18d1&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/scga-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ff18d1"]])

export default __exports__